import { toZonedTime, format as formatTZ } from 'date-fns-tz';

const UK_TIMEZONE = 'Europe/London';

/**
 * Convert a UTC timestamp string to UK local time (handles BST/GMT automatically)
 * @param {string} utcTimestamp - ISO timestamp string (UTC)
 * @param {string} formatStr - date-fns format string (default: 'HH:mm')
 * @returns {string} formatted time in UK timezone
 */
export function formatUK(utcTimestamp, formatStr = 'HH:mm') {
  if (!utcTimestamp) return '--:--';
  try {
    const date = new Date(utcTimestamp);
    const ukDate = toZonedTime(date, UK_TIMEZONE);
    return formatTZ(ukDate, formatStr, { timeZone: UK_TIMEZONE });
  } catch {
    return '--:--';
  }
}

/**
 * Parse a UTC timestamp to a UK-local Date object for calculations
 */
export function toUKDate(utcTimestamp) {
  if (!utcTimestamp) return null;
  return toZonedTime(new Date(utcTimestamp), UK_TIMEZONE);
}

export { UK_TIMEZONE };
